/** Mappings every area shares: people, collection refs and page links. */
import type { components } from '../api/generated/schema';
import type { CollectionRef } from '../domain/collections';
import type { PersonRef } from '../domain/people';

type S = components['schemas'];

export function toPersonRef(p: S['PersonRef']): PersonRef {
  return { id: p.id, firstName: p.first_name, lastName: p.last_name, avatarUrl: p.avatar_url };
}

export function toCollectionRef(c: S['CollectionRef']): CollectionRef {
  return { id: c.id, name: c.name };
}

/** One query parameter of a `next`/`previous` link, absolute or relative. */
export function queryParam(link: string | null | undefined, name: string): string | null {
  if (!link) return null;
  return new URL(link, 'http://link.invalid').searchParams.get(name);
}
